import styled from 'styled-components';

export default styled.div`
  background-image: linear-gradient(
    -90deg,
    #c9ccd6 0%,
    #e6e8ed 50%,
    #c9ccd6 100%
  );
  background-size: 400% 400%;
  animation: shimmer 1.2s ease-in-out infinite;

  @keyframes shimmer {
    0% {
      background-position: 0% 0%;
    }
    100% {
      background-position: -135% 0%;
    }
  }

  &.blue {
    background-image: linear-gradient(
      -90deg,
      #6f9eeb 0%,
      #b2c3de 50%,
      #6f9eeb 100%
    );
  }
`;
